import type { ReactNode } from 'react';

export const symbol_house_siding: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-240v90q0 13-8.5 21.5T231-120q-13 0-21.5-8.5T201-150v-402L99-475q-10 8-21.5 6.5T58-480q-8-10-6-22t12-20l380-290q8-6 17-9.5t19-3.5q10 0 19 3.5t17 9.5l380 290q10 8 11.5 20t-6.5 22q-8 10-19.5 11.5T860-475l-102-78v403q0 13-8.5 21.5T728-120q-13 0-21.5-8.5T698-150v-90H261Zm0-220h437v-100H261v100Zm0 160h437v-100H261v100Zm29-320h380L480-765 290-620Z"
		/>
	</svg>
);
